import { Component } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as _ from 'lodash';
import { select, Store } from '@ngrx/store';
import { EventManagerService } from 'src/app/services/event-manager.service';
import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';
import { ComponentPageService } from 'src/app/services/component-pages.service';
import { AppConfigService } from 'src/app/services/app-configuration.service';
import { FormOperationService } from 'src/app/services/form-manager.service';
import * as SettingsActions from 'src/app/store/settings/actions';
import * as Reducers from 'src/app/store/reducers';

@Component({
  selector: 'app-menu-left',
  templateUrl: './menu-left.component.html',
  styleUrls: ['./menu-left.component.scss'],
})
export class MenuLeftComponent {
  menuColor: String;
  isMenuShadow: Boolean;
  isMenuUnfixed: Boolean;
  isSidebarOpen: Boolean;
  isMobileView: Boolean;
  leftMenuWidth: Number;
  isMenuCollapsed: Boolean;
  logo: String;
  menuData: any[];
  menuDataActivated: any[];
  role: String;
  assetsBase: String;

  constructor(
    private _eventManager: EventManagerService,
    private _iconDictionary: IconDictionaryService,
    private store: Store<any>,
    private _router: Router,
    private _componentPageService: ComponentPageService,
    private _appConfig: AppConfigService,
    private _formOperationService: FormOperationService,
  ) {
    const userInfo = JSON.parse(localStorage.getItem('user'));
    this.role = userInfo ? userInfo.role : null;
    this._eventManager.subscribe('configLoaded', () => this.assetsBase = this._appConfig.getParameter('assetsBase'));
    this._eventManager.subscribe('sessionEstablished', () => this.menuInitialize());
    this._eventManager.subscribe('menuObtained', data => this.buildMenu(data.mainMenu));
  }

  menuInitialize() {
    this.store.pipe(select(Reducers.getSettings)).subscribe((state) => {
      this.menuColor = state.menuColor;
      this.isMenuShadow = state.isMenuShadow;
      this.isMenuUnfixed = state.isMenuUnfixed;
      this.isSidebarOpen = state.isSidebarOpen;
      this.isMobileView = state.isMobileView;
      this.leftMenuWidth = state.leftMenuWidth;
      this.isMenuCollapsed = state.isMenuCollapsed;
      this.logo = state.logo;
    });
    this._router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.activateMenu(event.url ? event.url : null);
      });
  }

  buildMenu(data) {
    this.menuData = this.preprocessMenudata(data);
    this.activateMenu(this._router.url);
  }

  activateMenu(url: any, menuData = this.menuData) {
    menuData = JSON.parse(JSON.stringify(menuData));
    const pathWithSelection = this.getPath({ url: url }, menuData, (entry: any) => entry, 'url');
    if (pathWithSelection) {
      pathWithSelection.pop().selected = true;
      _.each(pathWithSelection, (parent: any) => (parent.open = true));
    }
    this.menuDataActivated = menuData.slice();
  }

  getPath(element: any, source: any, property: any, keyProperty = 'key', childrenProperty = 'children', path = []) {
    let found = false;
    const getElementChildren = (value: any) => _.get(value, childrenProperty);
    const getElementKey = (value: any) => _.get(value, keyProperty);
    const key = getElementKey(element);
    return (
      _.some(source, (e: any) => {
        const key2 = key.slice(0, key.lastIndexOf('/'));
        const elem = getElementKey(e);
        if (elem === key || elem === key2) {
          path.push(e);
          return true;
        } else {
          return (found = this.getPath(
            element,
            getElementChildren(e),
            property,
            keyProperty,
            childrenProperty,
            path.concat(e),
          ));
        }
      }) &&
      (found || _.map(path, property))
    );
  }

  toggleSettings() {
    this.store.dispatch(
      new SettingsActions.SetStateAction({ isSidebarOpen: !this.isSidebarOpen }),
    );
  }

  onCollapse(value: any) {
    this.store.dispatch(
      new SettingsActions.SetStateAction({ isMenuCollapsed: value }),
    );
  }

  openPage(item) {
    this._formOperationService.openForm(null, { name: item.form });
  }

  preprocessMenudata(menuData) {
    menuData.forEach((item) => {
      if (item.form) {
        let pageUrl = `/${this._componentPageService.formRoute(item.form)}`;
        item.additionalInfo = (item.additionalInfo && !Array.isArray(item.additionalInfo))
          ? [item.additionalInfo] : item.additionalInfo;
        item.additionalInfo?.forEach(segment => pageUrl += `/${segment}`);
        item.url = pageUrl;
        item.key = item.form;
        item.iconName = (item.icon) ? this._iconDictionary.mapIcon(item.icon) : '';
      }
      if (item.children) {
        this.preprocessMenudata(item.children);
        item.iconName = (item.icon) ? this._iconDictionary.mapIcon(item.icon) : '';
      }
    });
    return menuData;
  }
}
